import React from 'react';
import { Typography, Tabs, Row, Col } from 'antd';
import { TopAmenities } from '../TopAmenities';

const { Paragraph } = Typography;

export const HotelOverview = ({ data, overviewRef }) => {

    function getImage(text) {
        let url = 'https://dhv90r5m1wdoe.cloudfront.net/web_assets/';
        switch (text) {
            case 'Location':
                return url + 'view.jpg';
            case 'Facilities':
                return url + 'facilities.jpg';
            case 'Rooms':
                return url + 'room.jpg';
            case 'Sports/Entertainment':
                return url + 'sports.jpg';
            case 'Misc.':
                return url + 'misc.jpg';
            case 'Payment':
                return url + 'payment.jpg';
            default:
                return url + 'meals.jpg';
        }
    }

    if (!Array.isArray(data?.texts) || data.texts.length <= 0) return null;

    const tabItems = Array.isArray(data?.texts) && data.texts
        .filter(e => e.para)
        .map((e, i) => {
            return {
                key: i,
                label: e.title === 'Meals' ? 'Dining' : e.title,
                children: (
                    <Row
                        className='p-3'
                        gutter={[24, 24]}
                    >
                        <Col
                            xs={{
                                span: 24,
                                order: 1
                            }}
                            md={{
                                span: 12,
                                order: 2
                            }}
                        >
                            <img
                                src={getImage(e.title)}
                                className='img img-fluid'
                                alt={e.title}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '10px'
                                }}
                            />
                        </Col>
                        <Col
                            xs={{
                                span: 24,
                                order: 2
                            }}
                            md={{
                                span: 12,
                                order: 1
                            }}
                        >
                            <div>
                                <h3 className='text-truncate mb-3'>
                                    {e.title === 'Meals' ? 'Dining' : e.title}
                                </h3>
                            </div>
                            <Paragraph className='fs-6'>
                                {e.para}
                            </Paragraph>
                        </Col>
                    </Row>
                )
            }
        }
        );

    const getOverViewText = () => {
        const text1 = Array.isArray(data?.texts) && data.texts.filter(e => e.para && e.title === 'Location');
        const text2 = Array.isArray(data?.texts) && data.texts.filter(e => e.para && e.title === 'Facilities');
        return (
            <React.Fragment>
                <Paragraph ellipsis={{ rows: 3, expandable: true, symbol: 'Read more' }} style={{ textAlign: 'justify' }}>
                    {
                        text1.length > 0 && text1[0].para ?
                            text1[0].para
                            :
                            ''
                    }
                    <br />
                    <br />
                    {
                        text2.length > 0 && text2[0].para ?
                            `${text2[0].para}`
                            :
                            ''
                    }
                </Paragraph>
            </React.Fragment>
        )
    }
    return (
        <React.Fragment>
            <div gutter={[24, 24]} className='mt-5 mb-2 mb-md-5'
                id='hotel-overview'
                ref={overviewRef}
            >
                {
                    Array.isArray(data?.texts) && data.texts.length &&
                    <h3 className='mb-3'>Overview</h3>
                }
                {
                    getOverViewText()
                }
                <h3 className='mt-4 mt-md-5 mb-3'>What this place offers</h3>
                <TopAmenities data={data} />

                <Tabs
                    defaultActiveKey="0"
                    tabPosition='top'
                    style={{
                        border: '2px solid #d3e6f8',
                        borderRadius: '10px',
                    }}
                    className='mt-5'
                >
                    {
                        tabItems.map(e => (
                            <Tabs.TabPane tab={e.label} key={e.key}
                                className='p-3'
                            >
                                {e.children}
                            </Tabs.TabPane>
                        ))
                    }
                </Tabs>
            </div>
        </React.Fragment>
    )
}
